<template>
  <el-dialog
    v-if="dialogVisible"
    ref="dialog"
    v-dialogDrag="isDrag"
    class="rc-dialog"
    :visible.sync="dialogVisible"
    :width="width"
    :append-to-body="appendToBody"
    :close-on-click-modal="closeOnClickModal"
    :custom-class="customClass"
    :top="top"
    v-bind="$attrs"
    v-on="$listeners"
    @close="handleClose"
  >
    <slot v-for="sl in slots" :name="sl">
      <component
        :is='isComponent'
        v-if="sl === 'default'"
        :ref="toTypeStr(contentType)"
        :show-search="showSearch"
        :auto-height-resize="autoHeightResize"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <template v-for="is in indexSlots" :slot="is" slot-scope="scope">
          <slot :name="is" v-bind="scope"></slot>
        </template>
      </component>
      <rc-but-list
        v-if="sl === 'footer'"
        class="dialog-footer"
        :but-data="comFooterBut"
        v-bind="$attrs"
        @confirm="dialogConfirm"
      ></rc-but-list>
    </slot>
  </el-dialog>
</template>

<script>
import RcDialogIndex from "./index.vue";
import RcButList from "../RcButList";
import { hasOwnProperty, emitFun, upperToLower, strFirstWith, toTypeStr, getApi } from "@/utils";
export default {
  name: "RcDialog",
  components: {
    RcDialogIndex,
    RcButList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "428px"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: "left",
      validator: () => ["top", "left"]
    },
    top: {
      type: String,
      default: "24vh"
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    isDrag: {
      type: Boolean,
      default: true
    },
    imgIcon: {
      type: String,
      // 删除：hint, 成功：success，重置：reset
      default: "hint"
    },
    contentType: {
      type: String,
      default: "dialogIndex"
      // validator: () => ['upload', 'dialogIndex', 'form', 'table']
    },
    footerButData: Array,
    dialogMerge: {
      type: Boolean,
      default: false
    },
    propSource: Object,
    beforeCancel: Function,
    beforeConfirm: Function,
    apiConfirm: {
      type: Object,
      default: () => ({
        model: "",
        name: ""
      })
    },
    apiConfirmParams: {
      type: Object,
      default: () => ({})
    },
    apiConfirmCall: Function,
    confirmReset: {
      type: Boolean,
      default: true
    },
    paramsStructure: Function,
    customRefresh: {
      type: Boolean,
      default: false
    },
    autoHeightResize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      load: {},
      slots: ["title", "default", "footer"],
      indexSlots: ["icon", "content"],
      ctSlots: ["upload", "dialogIndex", "form", "table", "dataTable"],
      defButData: [
        {
          prop: "cancel",
          label: this.$t("public.cancel"),
          plain: true
        },
        {
          prop: "confirm",
          label: this.$t("public.confirm"),
          type: ""
        }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    deleteLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    },
    comLeft() {
      return this.layout === "left";
    },
    customClass() {
      return `rc-dialog layout--${this.comLeft ? "left" : "top"}`;
    },
    comFooterBut() {
      const fbd = this.footerButData;
      const dbd = this.changeButData(this.defButData);
      return this[this.dialogMerge] ? [...fbd, ...dbd] : dbd || fbd;
    },
    isComponent() {
      return `rc-${upperToLower(this.contentType)}`;
    },
    refs() {
      return this.refsFun();
    },
    dialogForm() {
      return this.refs.dialogForm;
    },
    isApi() {
      return this.isApiFn("apiConfirm");
    }
  },
  methods: {
    toTypeStr,
    refsFun() {
      const ref = this.$refs;
      const obj = { ...ref };
      this.ctSlots.map(item => {
        const key = ref[item];
        if (key) { Object.assign(obj, { [item]: ref[item][0] }); };
      });
      return obj;
    },
    changeButData(arr) {
      if (!arr) { return arr; };
      return arr.map(item => {
        if (hasOwnProperty(item, "type")) {
          item.type = this.imgIcon === "hint" ? "danger" : "primary";
        }
        return item;
      });
    },
    dialogConfirm(item, index, obj) {
      emitFun({ self: this, emit: false }, { item, index }, { ... obj, refs: this, name: "rcDialog", propSource: this.propSource });
    },
    async apiPrecondition(parent, isCancel, call) {
      if (isCancel && this.isApi) {
        await call && call(parent, isCancel);
      };
    },
    dialogIndex(x, type) {
      const prop = this.propSource && this.propSource.prop;
      if (prop === "delete" && type) {
        this.$nextTick(() => {
          const { refs } = this.$parent;
          const self = refs.rcDataTable;
          self.initDelete();
          // self.refresh();
        });
      }
    },
    form(parent, isCancel) {
      this.apiPrecondition(parent, isCancel, form => {
        if (form.valid) {
          this.initApi(parent, () => {
            const { refs } = this.$parent;
            const table = refs && refs.rcDataTable;
            table && table.refresh();
          });
        }
      });
      return !(parent && parent.valid);
    },
    dataTable(parent, isCancel) {
      this.apiPrecondition(parent, isCancel, () => {
        this.initApi(parent, () => {
          const { refs } = this.$parent;
          const table = refs && refs.rcDataTable;
          table && table.refresh();
        });
      });
    },
    isApiFn(api) {
      const { model, name } = this[api];
      return model && name && model[name];
    },
    customStructure(params, other) {
      const { paramsStructure } = this;
      return paramsStructure ? paramsStructure(params, other) : params;
    },
    initApi(parent, call) {
      const newData = parent && parent.data || {};
      this.isApi && getApi({
        self: this,
        api: this.isApi,
        name: "dialog",
        params: this.customStructure({ ...newData, ...this.apiConfirmParams }, parent),
        call: this.apiConfirmCall || call,
        error: this.apiConfirmCall || call
      });
    },
    initType(type) {
      const isCancel = type !== "cancel";
      const refs = this.refsFun();
      const newContentType = toTypeStr(this.contentType);
      const parentFun = refs[newContentType][`dialog${strFirstWith(type)}`];
      const currentFun = this[newContentType];
      const beforeFun = this[`before${strFirstWith(type)}`];
      const parent = parentFun && parentFun();
      const current = currentFun && currentFun(parent, isCancel);
      const before = beforeFun && beforeFun({ parent, current, refs });
      this.$emit(`dialog-${type}`, parent, current, before);
      const state = Boolean(isCancel && (current || (beforeFun && (![undefined, null].includes(before) && !before))));
      this.$emit("update:visible", state);
      if (isCancel && !state && this.confirmReset) { this.cancel(); }
    },
    cancel(item, index, obj) {
      this.initType("cancel");
    },
    confirm(item, index, obj) {
      this.initType("confirm");
    },
    handleClose() {
      this.cancel();
    }
  }
};
</script>

<style scoped lang="scss">
.rc-dialog {
  ::v-deep .el-dialog__body {
    padding: 0 24px;
  }
  ::v-deep .el-dialog__close {
    color: $scim-text-color;
  }
}
.layout--left {
  .dialog-footer {
    text-align: right;
    padding-bottom: 4px;
    margin-bottom: 24px;
    ::v-deep .el-button {
      padding: 8px 16px;
      margin-left: 20px;
    }
  }
}
</style>
